import { IBooleanValueAction, IDateValueAction } from "../../../redux/actions";

export enum types {
  SET_CLOCK_AVAILABLE = "SET_CLOCK_AVAILABLE",
  SET_CLOCK_DATE = "SET_CLOCK_DATE"
}

export const setClockAvailable = (value: boolean): IBooleanValueAction => {
  return {
    type: types.SET_CLOCK_AVAILABLE,
    value
  };
};

export const setClockDate = (value: Date): IDateValueAction => {
  return {
    type: types.SET_CLOCK_DATE,
    value
  };
};
